import React, { useState } from "react";
import axios from "axios";
import BasePopup from "../../../Components/Base/BasePopup";
import DataGridComponent from "../../../Components/Forms/DataGridProComponent";
import { TextField } from "@mui/material";
import { Button } from "react-bootstrap";
import parse from 'html-react-parser';

const ConeDetalheViagemPopup = (props: any) => {
    const [criterioBusca, setCriterioBusca] = useState('');
    const [pageSize, setPageSize] = useState(20);
    const [responseRows, setResponseRows] = useState<any>();

    const colunas: any[] = [
        { dataIndex: 'id', title: 'Id Viagem', minWidth: 100, flex: 0.2, },
        { dataIndex: 'viagem_status', title: 'Status Viagem', minWidth: 150, flex: 0.2, },
        { dataIndex: 'operacao_nome', title: 'Operação', minWidth: 200, flex: 0.1, },
        { dataIndex: 'valor', title: 'Valor', render: (value: any) =>  `R$ ${value}` },
        { dataIndex: 'tipo_viagem', title: 'Tipo', minWidth: 200, flex: 0.1, },
        { dataIndex: 'mercadoria_nome', title: 'Mercadoria', minWidth: 200, flex: 0.1, },
        { dataIndex: 'motorista_nome', title: 'Motorista', minWidth: 250, flex: 0.1, },
        { dataIndex: 'veiculo_placa', title: 'Placa', minWidth: 100, flex: 0.1, },
        { dataIndex: 'veiculo_tecnologia', title: 'Tecnologia', minWidth: 100, flex: 0.2, },
        { dataIndex: 'mapa_coordenadas', title: 'Mapa', render: (value: string) => parse(`${(value ?? '')}`) },
        { dataIndex: 'origem_nome', title: 'Origem', minWidth: 250, flex: 0.1, },
        { dataIndex: 'destino_nome', title: 'Destino', minWidth: 250, flex: 0.1, },
    ];

    async function atualizaListaBuscaCallBack(pageSize: number, pageNumber: number = 1) {
        setPageSize(pageSize);

        try {
            // let ids_not_in = '';
            // let ids = '';


            if (props.ids == null || props.ids == '') {
                return null;
            }

            // if (props.currentKey == null) {
            //     return null;
            // }

            document.body.style.cursor = "wait";

            // if (props.currentKey == 'sucesso') {
            //     ids = props.dados['ids_status_em_viagem'];
            //     ids_not_in = concat(props.dados['ids_roubo'], props.dados['ids_acidente']);
            // }
            // else if (props.currentKey == 'sem-nc') {
            //     ids = props.dados['ids_total_viagens'];
            //     ids_not_in = props.dados['ids_nc'];
            // }
            // else if (props.currentKey == 'tratativa') {
            //     ids = concat(props.dados['ids_ocorrencias'], props.dados['ids_cto']);
            // }
            // else if (props.currentKey == 'evento') {
            //     ids = concat(props.dados['ids_roubo'], props.dados['ids_acidente']);
            // }
            // else if (props.currentKey == 'acumulado_risco') {
            //     ids = concat(props.dados['ids_perdas'], props.dados['ids_cto']);
            //     ids = concat(ids, props.dados['ids_ratc']);
            //     ids = concat(ids, props.dados['ids_acidente']);
            // }
            // else {
            //     ids = props.dados[`ids_${props.currentKey}`];
            //     if (ids == null || ids == '' || ids == '0') {
            //         return null;
            //     }

            //     let regra = props.dados[`usar_regra_${props.currentKey}`];
            //     if (regra != null && regra) {

            //         let ids_exception = props.dados['ids_ocorrencias'];
            //         ids_exception = concat(ids_exception, props.dados['ids_perdas']);
            //         ids_exception = concat(ids_exception, props.dados['ids_cto']);
            //         ids_exception = concat(ids_exception, props.dados['ids_ratc']);
            //         ids_exception = concat(ids_exception, props.dados['ids_acidente']);

            //         ids_not_in = ids_exception;
            //         ids = props.dados['ids_status_em_viagem'];

            //         if (props.dados[`ids_${props.currentKey}`] == 'total_risco_mais_ocorrencias_menos_status_em_viagem') {
            //             ids = ids_exception;
            //             ids_not_in = props.dados['ids_status_em_viagem'];
            //         }
            //     }
            // }

            let response = await axios.post(`coneDeRiscoDetalhes`,
                { 'page': pageNumber, 'pageSize': pageSize, 'ids': props.ids, 'ids_not_in': props.ids_not_in, 'criterio': criterioBusca });

            if (response?.data == null) {
                document.body.style.cursor = "default";
                return null;
            }

            setResponseRows(response);
        } catch (error) {
            console.log(error);
            document.body.style.cursor = "default";
        }
        finally {
            document.body.style.cursor = "default";
        }
    }

    // function concat(string1: string, string2: string) {
    //     let string1Invalida = string1 == null || string1 == '';
    //     let string2Invalida = string2 == null || string2 == '';
    //     if (string1Invalida && string2Invalida) {
    //         return '';
    //     }

    //     if (string2Invalida) {
    //         return string1;
    //     }

    //     if (string1Invalida) {
    //         return string2;
    //     }

    //     return string1 + ',' + string2;
    // }

    return (
        <div>
            <BasePopup title="Dados Viagens" isOpen={props.isOpen} onClose={props.onClose} hideButtonNew={true}>
                <span className="area-busca">
                    <TextField
                        onChange={(e) => setCriterioBusca(e.target.value)}
                        id="outlined-basic"
                        label="Busca"
                        variant="outlined"
                        className="col-md-9 col-12"
                        style={{ paddingRight: 10 }} />

                    <Button
                        onClick={async () => await atualizaListaBuscaCallBack(pageSize)}
                        style={{ marginTop: 10 }}
                        variant="contained"
                        className="col-md-3">
                        Buscar
                    </Button>
                </span>

                <DataGridComponent
                    heightFix={250}
                    responseRows={responseRows}
                    paginationSide="server"
                    hideButtons={true}
                    columns={colunas}
                    atualizaListaBuscaCallBack={atualizaListaBuscaCallBack} />
            </BasePopup>
        </div>
    );
}

export default ConeDetalheViagemPopup;
